@if (customField13==0) {

@if(newPopup === 2 ){
<div class="new-popup-styles" fxLayout="row" style="padding:10px 0px;" fxShow fxHide.lt-md>
  <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">
    @for (field of fields; track field) {
    @if (!field.enableConditionalField || field.visible) {
    @if (field.inputType !== 'button') {
    <div [fxFlex]="layout == 2 ? 
        (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
        : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
          : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
            : '100'))">
      <div dynamicField (valueChange)="onFieldValueChange($event)" [field]="field" [group]="form"></div>
    </div>
    } @else {
    @if (EnablePayment==0 && !enableFormPayment) {
    <div fxFlex="100" class="submission-loader">
      <ng-container *ngIf="!disabledButton; else redirecting">
        <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton ? 'gray' : 'white' }"
          [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>
          {{ field.label }}
        </button>
      </ng-container>

      <ng-template #redirecting>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="18px" fxFlex="100" style="padding: 2rem 0;">
          <!-- <span style="font-weight: bold; font-size: 1.2rem; color: #FF3D00;">Redirecting</span> -->
          <span class="loader"></span>
        </div>
      </ng-template>

    </div>


    }
    }
    }
    }
    @if (formValid && enableFormPayment) {
    <div>
      <!-- <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
        [finalAmount]="amount"></app-razor-pay> -->
    </div>
    }
  </div>
</div>
}

@if(newPopup != 2 ){
<div>
  @if (formInit) {
  <div fxLayout="row " fxShow fxHide.lt-md>
    <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">
      @for (field of fields; track field) {
      @if (!field.enableConditionalField || field.visible) {
      @if (field.inputType !== 'button') {
      <div [fxFlex]="layout == 2 ? 
          (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
          : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
            : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
              : '100'))">
        <div dynamicField (valueChange)="onFieldValueChange($event)" [field]="field" [group]="form"></div>
      </div>
      } @else {
      @if (EnablePayment==0 && !enableFormPayment) {
      <div fxFlex="100" class="submission-loader-two">
      <ng-container *ngIf="!disabledButton; else redirecting">
        <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton ? 'gray' : 'white' }"
          [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>
          {{ field.label }}
        </button>
      </ng-container>

      <ng-template #redirecting>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="18px" fxFlex="100" style="padding: 2rem 0;">
          <!-- <span style="font-weight: bold; font-size: 1.2rem; color: #FF3D00;">Redirecting</span> -->
          <span class="loader"></span>
        </div>
      </ng-template>

    </div>
      }
      }
      }
      }
      @if (formValid && enableFormPayment) {
      <div>
        <!-- <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount"></app-razor-pay> -->
      </div>
      }
    </div>
  </div>
  }

</div>
}
}

@if (customField13==0) {
<div>
  @if(newPopup === 2 ){
  <div class="new-popup-styles" fxLayout="row" style="padding:10px 0px;" fxShow fxHide.gt-sm>
    <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">
      @for (field of fields; track field) {
      @if (!field.enableConditionalField || field.visible) {
      @if (field.inputType !== 'button') {
      <div [fxFlex]="layout == 2 ? 
          (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
          : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
            : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
              : '100'))">
        <div dynamicField (valueChange)="onFieldValueChange($event)" [field]="field" [group]="form"></div>
      </div>
      } @else {
      @if (EnablePayment==0 && !enableFormPayment) {
      <div fxFlex="100" class="submission-loader">
        <ng-container *ngIf="!disabledButton; else redirecting">
          <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton ? 'gray' : 'white' }"
            [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>
            {{ field.label }}
          </button>
        </ng-container>

        <ng-template #redirecting>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="18px" fxFlex="100" style="padding: 2rem 0;">
            <!-- <span style="font-weight: bold; font-size: 1.2rem; color: #FF3D00;">Redirecting</span> -->
            <span class="loader"></span>
          </div>
        </ng-template>

      </div>
      }
      }
      }
      }
      @if (formValid && enableFormPayment) {
      <div>
        <!-- <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount"></app-razor-pay> -->
      </div>
      }
    </div>
  </div>
  }
  @if (formInit && newPopup != 2) {
  <div fxShow fxHide.gt-sm fxLayout="column">
    <div style="box-sizing: border-box;width: 100%;" [formGroup]="form" [fxLayoutGap]="gapBetweenImage"
      fxLayout="column">
      @for (field of fields; track field) {
      <ng-container style="width: 100%;">
        @if (!field.enableConditionalField || field.visible) {
        @if (field.inputType !== 'button') {
        <ng-container style="width: 100%;">
          <div [fxFlex]="layout == 2 ? 
        (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
        : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
          : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
            : '100'))">
            <div dynamicField [field]="field" [group]="form"></div>
          </div>
        </ng-container>
        } @else {
        @if (EnablePayment==0 && !enableFormPayment) {
        <div fxFlex="100" class="submission-loader-two">
      <ng-container *ngIf="!disabledButton; else redirecting">
        <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton ? 'gray' : 'white' }"
          [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>
          {{ field.label }}
        </button>
      </ng-container>

      <ng-template #redirecting>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="18px" fxFlex="100" style="padding: 2rem 0;">
          <!-- <span style="font-weight: bold; font-size: 1.2rem; color: #FF3D00;">Redirecting</span> -->
          <span class="loader"></span>
        </div>
      </ng-template>

    </div>
        }
        }
        }
      </ng-container>
      }
      @if (formValid && enableFormPayment) {
      <div>
        <!-- <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount">
        </app-razor-pay> -->
      </div>
      }
    </div>
  </div>
  }
</div>
}

@if (customField13==1) {
<div fxLayoutAlign="center center">
  @if (formInitSecond) {
  <div>
    <!-- <calsoft-sub-form [layout]="layout" (submit)="submitSecondForm($event)" [formGroupId]="newFormField">
    </calsoft-sub-form> -->
  </div>
  } @else {
  @if (formInit) {
  <div fxLayout="row" class="cards" fxLayoutAlign="center center">
    <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">
      <ng-container>
        <div fxLayout="column">
          <div fxLayout="row wrap" fxLayoutAlign="start start">
            @for (field of valuesInputed; track field; let i = $index) {
            <div>
              @if (form.value[field]!=null &&form.value[field]!=undefined ) {
              <div>
                @if (form.value[field].length>0) {
                <div>
                  @if (!field.includes('image')) {
                  <div class="button-cards" (click)="goToState(i)">
                    {{ form.value[field] }}
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>
        <ng-container>
          <div [fxFlex]="'100'">
            @if (dontDisplayBackButton) {
            <button style="border: none; margin-top: 5px;" (click)="back()">
              <mat-icon>keyboard_backspace</mat-icon>
            </button>
            }
            @if (formInit1) {
            <div>
              @if (objectTobeDisplayed.inputType=='image') {
              <div>
                <!-- <calsoft-image (valueChange)="onFieldValueChange($event)" [field]="objectTobeDisplayed" [group]="form">
                </calsoft-image> -->
              </div>
              }
              @if (objectTobeDisplayed.inputType=='select') {
              <div>
                <calsoft-select (valueChange)="onFieldValueChange($event)" [field]="objectTobeDisplayed" [group]="form">
                </calsoft-select>
              </div>
              }
              @if (objectTobeDisplayed.inputType=='text') {
              <div>
                <div>
                  <calsoft-input [customField13]="customField13" (valueChange)="onFieldValueChange($event)"
                    [field]="objectTobeDisplayed" [group]="form">
                  </calsoft-input>
                </div>
              </div>
              }
              @if (objectTobeDisplayed.inputType=='file') {
              <div>
                <!-- <calsoft-file-upload (valueChange)="onFieldValueChangeImage($event)" [customField13]="customField13"
                  [field]="objectTobeDisplayed" [group]="form">
                </calsoft-file-upload> -->
              </div>
              }
              @if (objectTobeDisplayed.inputType=='button') {
              <div>
                <div fxFlex="100" [formGroup]="form">
                  @for (field of fields; track field) {
                  @if (field.inputType == 'button') {
                  <button (click)="onSubmit()" fxFlex type="submit" style="color:white" mat-raised-button
                    class="primary">{{field.label}}</button>
                  }
                  }
                </div>
              </div>
              }
            </div>
            }
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  }
  }
</div>
}

@if (customField13==2) {
<div fxLayoutAlign="center center">
  @if (formInitSecond) {
  <div>

    <!-- <calsoft-sub-form [layout]="layout" (submitSubForm)="SecondFormSubmitnew($event)" [formGroupId]="newFormField">
    </calsoft-sub-form> -->

    @if (customField13==2) {
    <div class="gapbottom" fxLayoutAlign="end center">
      <button fxFlex="100" (click)="newForm()" style="color:white" mat-raised-button class="primary">Submit</button>
    </div>
    }
  </div>
  }

  @if (formInit) {
  <div fxLayout="row " fxShow fxHide.lt-md>

    <div fxLayout="row wrap" fxFlex="100" [formGroup]="form" [fxLayoutGap]="gapBetweenImage">

      @for (field of fields; track field) {
      <ng-container>

        <ng-container>
          @if (field.inputType !== 'button') {
          <ng-container>
            <div [fxFlex]="layout == 2 ? 
          (gapBetweenImage ?  'calc(50% - ' + (gapBetweenImage) + ')' : '50%') 
          : (layout == 3 ? (gapBetweenImage ? 'calc(33.33% - ' + gapBetweenImage + ')' : '33.33%') 
            : (layout == 4 ? (gapBetweenImage ? 'calc(25% - ' + gapBetweenImage + ')' : '25%') 
              : '100'))">

              <div dynamicField (valueChange)="onFieldValueChange($event)" [field]="field" [group]="form"></div>
            </div>
          </ng-container>
          }@else() {
          <ng-template #buttonContainer>
            @if (EnablePayment==0 && !enableFormPayment) {
            <div fxFlex="100">
              <button class="primary" fxFlex [ngStyle]="{ 'color': disabledButton? 'gray' : 'white' }"
                [disabled]="disabledButton" (click)="onSubmit()" mat-raised-button>

                {{disabledButton?'Processing': field.label}}
                @if (disabledButton) {
                <mat-icon>
                  <mat-spinner class="primary" diameter="20">
                  </mat-spinner>
                </mat-icon>
                }
              </button>
            </div>
            }
          </ng-template>
          }
        </ng-container>
      </ng-container>
      }

      <!-- <div *ngIf="customField13==2" class="gapbottom" fxLayoutAlign="end center">
          <button fxFlex="100" (click)="newForm()"  type="submit" style="color:white" mat-raised-button
          class="primary">Submit</button>
        </div> -->
      @if (formValid && enableFormPayment) {
      <div>
        <!-- <app-razor-pay [contact]="contact" [partialAmountEnabled]="0" (paymentStatus)="paymentResponceRazorPAy($event)"
          [finalAmount]="amount"></app-razor-pay> -->

      </div>
      }

    </div>
  </div>
  }

</div>
}

@if (EnablePayment==1) {
<div class="margin-t10">

  <div class="gapbottom" fxLayoutAlign="center center">
    <button [disabled]="disabledButton" style="color: white; width: 150px; height: 45px;" class="primary"
      (click)="onSubmit()" mat-raised-button>
      Submit
    </button>
  </div>

  <div class="policy" style="padding-top: 4%; font-size: 20px;">
    I have read, understood, and hereby accept the User Agreement, Terms and Conditions along with Cancellation and
    Refund Policy. I permit Webotel enterprise to process ahead with my subscription plan for my property.
    I also expressly allow to store and process my information for further coordination and promotional activities.
  </div>

  <div fxLayoutAlign="center center" style="padding-top: 2%;">

    <div>
      <h2>Please accept our policy documents:</h2>
      <form [formGroup]="termsForm">
        <div>
          <input type="checkbox" formControlName="userAgreement" id="userAgreement" />
          <label for="userAgreement">User Agreement</label> &nbsp;&nbsp;&nbsp;

          <button mat-button (click)="policyPopup('userAgreement')">
            View
          </button>

        </div>
        <div>
          <input type="checkbox" formControlName="termsConditions" id="termsConditions" />
          <label for="termsConditions">Terms & Conditions</label> &nbsp;&nbsp;&nbsp;

          <button mat-button (click)="policyPopup('terms')">
            View
          </button>

        </div>
        <div>
          <input type="checkbox" formControlName="cancellationPolicy" id="cancellationPolicy" />
          <label for="cancellationPolicy">Cancellation Policy</label> &nbsp;&nbsp;&nbsp;

          <button mat-button (click)="policyPopup('cancellationPolicy')">
            View
          </button>

        </div>
        <div>
          <input type="checkbox" formControlName="refundPolicy" id="refundPolicy" />
          <label for="refundPolicy">Refund Policy</label> &nbsp;&nbsp;&nbsp;


          <button mat-button (click)="policyPopup('returnPolicy')">
            View
          </button>

        </div>
      </form>
    </div>

  </div>
  <!-- <calsoft-subscription-plan [SuccessMessage]="SuccessMessage" [FailerMessage]="FailerMessage"
          [redirectUrl]="redirectUrl" fxFlex="100" [type]="'3'"></calsoft-subscription-plan> -->

  <div>
    <!-- <calsoft-subscription-plan [SuccessMessage]="SuccessMessage" [FailerMessage]="FailerMessage"
      [redirectUrl]="redirectUrl" [enablePayment]="termsForm?.valid" fxFlex="100"
      [type]="'3'"></calsoft-subscription-plan> -->
  </div>
</div>
}


@if (calculaterEnable) {
<div class="margin-t10">
  {{calculatedValue}}
</div>
}

<!-- @if (showResult) { -->
<div class="margin-t10">
  @if (calculaterEnable) {
  <div class="result-card">
    <h3>Your Result</h3>
    <div class="result-value">
      <p>Revenue / Sales</p>
      <h2> {{calculatedValue}}/-</h2>
    </div>
    @for (item of mergedObj | keyvalue; track item) {
    @for (item of mergedObj | keyvalue; track item) {
    <div class="result-details">
      <p>{{item.key}}</p>
      <p>{{item.value}}</p>
    </div>
    }
    }
    <!-- <button mat-raised-button color="primary">Get Started</button> -->
  </div>
  }
</div>
<!-- } -->